import styles from './dataTypeSelectorTable.module.css'
import { Column, FieldType, Option, SelectorTable } from '../../../ui'
import { Data2 } from '../../types'

type Props = {
    rows?: Data2[]
    columns?: Column[]
    options: Option[]
    placeholder?: string
    emptyMessage?: string
    readOnly?: boolean
    rowData?: (id: string) => Promise<Data2>
    renderOption?: (option: Option) => Promise<JSX.Element>
    onChange: (data: Data2[]) => void
}

export const DataTypeSelectorTable = (props: Props) => {
    const { rows, columns, options, placeholder, emptyMessage, readOnly, rowData, renderOption, onChange } = props

    const columnsList: Column[] = columns || [
        {
            name: 'code',
            type: FieldType.TEXT,
            label: '#'
        }
    ]

    const defaultRowData = async (id: string) => {
        return options.find(option => option.value === id)!
    }

    return options.length > 0 ? (
        <SelectorTable
            rowId="id"
            rowsData={rows}
            columns={columnsList}
            options={options}
            placeholder={placeholder}
            rowData={rowData || defaultRowData}
            renderOption={renderOption}
            readOnly={readOnly}
            onChange={onChange}
        />
    ) : (
        <div className={styles.empty}>
            <span>{emptyMessage || 'Esta tabla está vacía.'}</span>
        </div>
    )
}
